module.exports = __webpack_public_path__ + "img/seloMedalhaOuro.6eea8638.png";